import { CONFIG } from '../client-config'
import { arrayToObject } from './index'

export const CONFIG_KEYS = arrayToObject(CONFIG)

export const getClientConfigValue = configKey => {
  if (typeof window === 'undefined') {
    return process.env[configKey] // eslint-disable-line no-process-env
  } else {
    return window.__ENV__ && window.__ENV__[configKey]
  }
}

export const getClientConfigBool = configKey =>
  getClientConfigValue(configKey) === 'true'
